import * as React from 'react';
import { useField } from 'react-final-form';
import { Choice, ChoiceGroup } from '@gandi/ui';
import { ErrorMessage } from '../../components';
import { useFieldError } from '../hooks/errors';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function ChoiceField({
  name,
  value,
  ...choiceProps
}) {
  // retrieve props accepted by `Choice` component
  // FinalForm needs a type radio or checkbox in order to know how to handle the value
  const {
    input: {
      multiple,
      onBlur,
      onFocus,
      ...inputRest
    }
    // $FlowFixMe[prop-missing] FinalForm's UseFieldConfig definition isn't compatible with exact_by_default
  } = useField(name, {
    type: 'radio',
    value
  });

  // $FlowFixMe[incompatible-type]: useField input props is inexact but choice props is …
  return /*#__PURE__*/_jsx(Choice, {
    ...choiceProps,
    ...inputRest
  });
}
/**
 * USAGE:
 * ```
 * <ChoiceFieldGroup name="something">
 *   <ChoiceField name="something" value="a" label="First">
 *     <span slot="addon">This is A addon</span>
 *   </ChoiceField>
 *   <ChoiceField name="something" value="b" label="Second">
 *     <span slot="addon">This is B addon</span>
 *     <div slot="additional">This is B additional</div>
 *   </ChoiceField>
 * </ChoiceFieldGroup>
 * ```
 */
export function ChoiceFieldGroup(props) {
  const {
    name,
    choiceGroupProps,
    children,
    validate
  } = props;

  // $FlowFixMe[prop-missing] FinalForm's UseFieldConfig definition isn't compatible with exact_by_default
  useField(name, {
    validate
  });
  const error = useFieldError(props.name);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ChoiceGroup, {
      ...choiceGroupProps,
      children: children
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      text: error
    })]
  });
}